import { render, staticRenderFns } from "./ReceiptType.vue?vue&type=template&id=12dca6ee&scoped=true"
import script from "./ReceiptType.vue?vue&type=script&lang=js"
export * from "./ReceiptType.vue?vue&type=script&lang=js"
import style0 from "./ReceiptType.vue?vue&type=style&index=0&id=12dca6ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dca6ee",
  null
  
)

export default component.exports